import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Location } from '@angular/common';
import { Component, Input, OnInit, Optional } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  getInstanceRegion,
  isLargeScreen,
} from '../../../../../global.variable';
import { AddEditSiteComponent } from '../../../../shared/components/add-edit-site/add-edit-site.component';
import { DialogRef } from '../../../../shared/components/modal-dialogue/modal-dialogue.ref';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { ClientsService } from '../../clients/clients.service';
import { UserPromptService } from '../../user-prompts/user-prompt.service';
import { CheckpointService } from '../checkpoint.service';
@Component({
  selector: 'gtapp-add-edit-checkpoint',
  templateUrl: './add-edit-checkpoint.component.html',
  styleUrl: './add-edit-checkpoint.component.scss',
  standalone: false,
})
export class AddEditCheckpointComponent implements OnInit {
  @Input()
  checkPointForm: UntypedFormGroup = new UntypedFormGroup({
    name: new UntypedFormControl('', [Validators.required]),
    company: new UntypedFormControl('', Validators.required),
    company_id: new UntypedFormControl('', Validators.required),
    site: new UntypedFormControl(''),
    site_id: new UntypedFormControl(''),
    min_distance: new UntypedFormControl(100, [
      Validators.max(1000),
      Validators.min(10),
      Validators.required,
    ]),

    description: new UntypedFormControl(),
    address1: new UntypedFormControl(''),
    address2: new UntypedFormControl(''),
    address3: new UntypedFormControl(),
    city_name: new UntypedFormControl('', [Validators.required]),
    state_code: new UntypedFormControl('', [Validators.required]),
    state_name: new UntypedFormControl('', [Validators.required]),
    country_name: new UntypedFormControl(getInstanceRegion(), [
      Validators.required,
    ]),
    postcode: new UntypedFormControl(''),
    longitude: new UntypedFormControl('', [Validators.required]),
    latitude: new UntypedFormControl('', [Validators.required]),
  });

  showMap: boolean = false;
  latLon: any;
  largeView: Boolean = isLargeScreen;
  distanceFromLocation: any;

  siteListData: any = [];

  addressLookupData: any;

  minKm: number = 5;
  maxKm: number = 1000;
  nearestKmValue = 100;
  currentStep: number = 1;

  // prompt variables
  selectedUserPrompts: any = [];
  availableUserPrompts: any = [];

  userPromptsRows: number = 7;
  userPromptsPrevious: number = 0;
  userPromptsPageNum: number = 1;
  userPromptsTotalPages: number = 0;
  userPromptsTotalCount: number = 0;
  userPromptsSearchResults: any = [];

  searchClientValue: string = '';
  searchSiteValue: string = '';
  addBtnPressed: boolean = false;

  initialSiteDataList: any = [];

  selectedSite: any;
  isCheckpointFormValid: boolean = true;

  constructor(
    private checkpointService: CheckpointService,
    private spinnerService: LoadingSpinnerService,
    private dialogService: ModalDialogueService,

    private _location: Location,
    private router: Router,
    @Optional() protected dialogref: DialogRef,
    private userPromptService: UserPromptService,
    private toasterService: ToasterService,
    private clientService: ClientsService,
  ) {}

  ngOnInit() {
    this.currentStep = 1;
    this.shiftFocus('cpName');
    this.getUserPrompts();
    this.siteLookupApi('');

    let fromSiteInfo = JSON.parse(sessionStorage.getItem('fromSite') || '{}');
    if (Object.keys(fromSiteInfo).length) {
      this.checkPointForm.controls['site_id'].setValue(fromSiteInfo?.site?.id);
      this.checkPointForm.controls['site'].setValue(
        fromSiteInfo?.site?.company_name,
      );

      this.checkPointForm.controls['company_id'].setValue(
        fromSiteInfo?.client?.id,
      );
      this.checkPointForm.controls['company'].setValue(
        fromSiteInfo?.client?.company_name,
      );
      sessionStorage.removeItem('fromSite');
      this.getSiteDetailById(fromSiteInfo?.site?.id);
    }
    let fromClientInfo = JSON.parse(
      sessionStorage.getItem('fromClient') || '{}',
    );
    if (Object.keys(fromClientInfo).length) {
      this.checkPointForm.controls['company_id'].setValue(
        fromClientInfo?.client?.id,
      );
      this.checkPointForm.controls['company'].setValue(
        fromClientInfo?.client?.company_name,
      );
      sessionStorage.removeItem('fromClient');
    }
  }

  onSiteSelect(data: any) {
    if (data?.key === 0) {
      this.openAddSiteForm();
      this.checkPointForm.controls['site_id'].setValue(null);
      this.checkPointForm.controls['site'].setValue(null);
    }
    if (data?.id) {
      this.selectedSite = data;
      this.getSiteDetailById(data?.id);

      this.checkPointForm.controls['site_id'].setValue(data.id);
      this.checkPointForm.controls['site'].setValue(data.company_name);

      if (data?.company) {
        this.checkPointForm.controls['company_id'].setValue(data?.company?.id);
        this.checkPointForm.controls['company'].setValue(
          data?.company?.company_name,
        );
      }
    }
  }
  getSiteDetailById(siteId: any) {
    this.spinnerService.show('Fetching Site Information');
    let siteFields = ['address'];
    // getting site information for static guards

    this.clientService
      .getSiteDetailsById(siteId, {
        get_details: 1,
        site_fields: JSON.stringify(siteFields),
      })
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.selectedSite = {
            ...this.selectedSite,
            ...response?.data,
          };
          this.addressSelected(response?.data?.address);
        }
      });
  }
  openAddSiteForm() {
    const dialogRef = this.dialogService.open(AddEditSiteComponent, {
      data: {
        detailData: {
          company_name: this.searchSiteValue,
          address: this.checkPointForm.value,
        },
      },
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data !== 'close') {
        this.onSiteSelect(data);
      }
    });
  }

  shiftFocus(elementId: string, time: number = 100) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      if (element) {
        element?.focus();
      }
    }, time);
  }

  isFirstStepInvalid() {
    return (
      this.checkPointForm.controls['address2'].invalid ||
      this.checkPointForm.controls['postcode'].invalid ||
      this.checkPointForm.controls['city_name'].invalid ||
      this.checkPointForm.controls['state_code'].invalid ||
      this.checkPointForm.controls['name'].invalid ||
      this.checkPointForm.controls['min_distance'].invalid
    );
  }

  addressSelected(address: any) {
    if (address && typeof address === 'object') {
      this.latLon = null;
      setTimeout(() => {
        this.checkPointForm.controls['name'].updateValueAndValidity();

        this.checkPointForm.controls['address1'].setValue(address?.address1);
        this.checkPointForm.controls['address2'].setValue(address?.address2);
        this.checkPointForm.controls['address3'].setValue(address?.address3);
        this.checkPointForm.controls['city_name'].setValue(address?.city_name);
        this.checkPointForm.controls['postcode'].setValue(address?.postcode);
        this.checkPointForm.controls['state_code'].setValue(
          address?.state_code || address?.state_name,
        );
        this.checkPointForm.controls['state_name'].setValue(
          address?.state_name || address?.state_code,
        );

        this.checkPointForm.controls['country_name'].setValue(
          address?.country_name || getInstanceRegion(),
        );

        this.checkPointForm.controls['latitude'].setValue(address?.latitude);
        this.checkPointForm.controls['longitude'].setValue(address?.longitude);
        this.latLon = { lat: 0, lon: 0 };
        this.latLon.lat = address?.latitude;
        this.latLon.lon = address?.longitude;
        this.isCheckpointFormValid = !this.isAddressInvalid();

        this.showMap = true;
      });
    }
  }
  isAddressInvalid() {
    const fields = [
      'city_name',
      'state_code',
      'state_name',
      'latitude',
      'longitude',
      'country_name',
    ];

    return fields.some((field) => {
      const control = this.checkPointForm.controls[field];
      return control.validator && control.invalid;
    });
  }
  onCloseDialogue() {
    this.dialogref.close(false);
  }
  emitData(event: any) {
    this.checkPointForm.controls['latitude'].setValue(event.lat);
    this.checkPointForm.controls['longitude'].setValue(event.lng);
  }
  addCheckpointCount() {
    let subscriberStats = JSON.parse(
      localStorage.getItem('subscriberStats') || '{}',
    );
    subscriberStats.checkpoint_count =
      (subscriberStats?.checkpoint_count || 0) + 1;
    localStorage.setItem('subscriberStats', JSON.stringify(subscriberStats));
  }
  updateMinDistance(event: any) {
    this.checkPointForm.controls['min_distance'].setValue(event);
  }

  onClickSubmit() {
    let requestData = this.checkPointForm.value;

    if (requestData.site_id == null || requestData.site_id == undefined) {
      delete requestData.site_id;
    }
    if (this.selectedUserPrompts?.length) {
      requestData['user_prompt_ids'] = [
        ...new Set(this.selectedUserPrompts?.map((prompt: any) => prompt?.id)),
      ];
    }

    this.addBtnPressed = true;
    this.spinnerService.show();
    this.checkpointService.addCheckPoint(requestData).then((response: any) => {
      if (response['status'] == 'success') {
        this.addCheckpointCount();

        this.checkPointForm.reset();

        this.toasterService.setMessage({
          successMessage: response['message'],
          errorMessage: '',
        });
        this._location.back();
      } else {
        this.addBtnPressed = false;
        this.toasterService.setMessage({
          errorMessage: response['message'],
          successMessage: '',
        });
      }
      this.spinnerService.hide();
    });
  }

  onSiteSearch(event: any) {
    this.searchSiteValue = event.target.value;
    if (event.target.value.length > 2) {
      this.siteLookupApi(event.target.value);
    }
  }
  siteLookupApi(searchStr?: any) {
    this.clientService
      .searchSites({
        search_str: searchStr,
        is_active: 1,
      })
      .subscribe((res: any) => {
        if (res['status'] == 'success') {
          this.siteListData = res?.data?.splice(0, 10);
          if (!searchStr) {
            this.initialSiteDataList = JSON.parse(
              JSON.stringify(this.siteListData),
            );
          }
        }
      });
  }

  goBack() {
    this.showMap = false;
    this.spinnerService.show();
    setTimeout(() => {
      this.showMap = true;
      this.spinnerService.hide();
    }, 200);
  }
  searchPrompts(event: any) {
    if (event.target.value?.length > 2) {
      const params: any = { search_str: event.target.value };
      this.userPromptService
        .getUserPromptList(params)
        .subscribe((response: any) => {
          this.userPromptsSearchResults = response?.data?.filter(
            (value1: any) =>
              !this.selectedUserPrompts.some(
                (value2: any) => value1?.id === value2?.id,
              ),
          );
        });
    }
  }

  onLoadMore() {
    this.userPromptsPrevious = this.userPromptsPrevious + this.userPromptsRows;
    this.getUserPrompts();
  }
  getUserPrompts(event?: any) {
    let params: any = {};
    if (this.userPromptsRows) {
      params['rows'] = this.userPromptsRows;
    }
    if (this.userPromptsPrevious) {
      params['previous'] = this.userPromptsPrevious;
    }

    if (event?.target?.value) {
      params['name'] = event.target.value;
    }

    this.userPromptService
      .getUserPromptList(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          response?.data.forEach((item1: any) => {
            if (
              !this.availableUserPrompts.some(
                (item2: any) => item1?.id === item2?.id,
              )
            ) {
              this.availableUserPrompts.push(item1);
            }
          });
          this.updateUserPromtOrder();
          this.userPromptsTotalCount = response['total_size'];
          this.userPromptsTotalPages = Math.ceil(
            this.userPromptsTotalCount / this.userPromptsRows,
          );
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }

  addRemoveUserPrompt(userPrompt: any) {
    userPrompt.selected = !userPrompt?.selected;
    const promptIndex = this.availableUserPrompts?.findIndex(
      (prompt: any) => userPrompt?.id == prompt?.id,
    );
    if (promptIndex > -1) {
      this.availableUserPrompts[promptIndex] = userPrompt;
    } else {
      this.availableUserPrompts.push(userPrompt);
    }

    this.selectedUserPrompts = this.availableUserPrompts?.filter(
      (prompt: any) => prompt?.selected,
    );

    setTimeout(() => {
      this.updateUserPromtOrder();
    }, 100);
  }

  dropUserPrompt(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.availableUserPrompts,
      event.previousIndex,
      event.currentIndex,
    );
  }
  updateUserPromtOrder() {
    this.availableUserPrompts.sort((a: any, b: any) => {
      if (a.selected === b.selected) {
        return 0;
      }
      return a.selected ? -1 : 1;
    });
  }
  editField(field: string) {
    if (field == 'name') {
      this.checkPointForm.controls['name'].setValue(null);
      this.shiftFocus('cpName');
    } else if (field == 'site') {
      this.checkPointForm.controls['site_id'].setValue(null);
      this.checkPointForm.controls['site'].setValue(null);

      this.checkPointForm.controls['company_id'].setValue(null);
      this.checkPointForm.controls['company'].setValue(null);
      this.siteListData = JSON.parse(JSON.stringify(this.initialSiteDataList));

      this.shiftFocus('siteId');
    }
  }
}
